/** Browser entry: renders {@link LoginPage} with the dictionary for `navigator.language`. */
import { createRoot } from 'react-dom/client'
import { LoginPage } from './LoginPage.tsx'
import { pickMessages } from './locales.ts'
import './global.css'

const messages = pickMessages(navigator.language)
document.documentElement.lang = messages.lang
document.title = messages.documentTitle

const container = document.getElementById('root')
if (container === null) throw new Error('sinocst-login: index.html has no #root element')
createRoot(container).render(<LoginPage messages={messages} navigation={window.location} />)
